import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Toast } from "../../Components";
import { parseInput } from "../../Components/Constants/AppConstant";
import { dataCollectionService } from "../../Services/dataCollection.service";
import React, { useState } from "react";

export const HandlePost = () => {
  const [input, setInput] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [toastList, setToastList] = useState([]);

  const navigate = useNavigate();

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const handleInput = (e) => {
    setInput(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const apiData = {
      handle: input,
    };
    try {
      const res = await dataCollectionService.searchHandle(apiData);
      if (res && res.success === true) {
        console.log("Response Data:", res);
        setInput("");
        addToast({
          error: false,
          msg: res.message || "Data fetched successfully!",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    } catch (err) {
      if (err.apiResponseStatus != 404) {
        let error = parseInput(err.message);
        addToast({
          error: true,
          msg: error.message,
          id: `${Date.now()}-${toastList.length}`,
        });
      } else {
        setIsLoading(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const goBack = () => {
    navigate(-1);
  };
  return (
    <div className="max-w-full mx-auto px-4 py-4 space-y-4">
      <div className="flex justify-start mt-0">
        <button
          className="w-full sm:w-auto order-2 sm:order-1 px-4 py-2 bg-white border border-emerald-100 rounded-lg hover:bg-emerald-50 hover:border-emerald-400 transition-all duration-200 font-medium shadow-sm flex justify-start"
          onClick={goBack}
        >
          <ArrowLeft color="#374151" />{" "}
          <span className="text-gray-700 ml-1">Back</span>
        </button>
      </div>
      <div className="flex justify-center gap-5 mt-5 ">
        <input
          type="text"
          value={input}
          placeholder="Search..."
          className=" w-[50%] rounded-3xl border md:border-green-600 md:bg-white justify-center pl-5"
          onChange={handleInput}
        />
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={isLoading || !input.trim()}
          className="cursor-pointer bg-gradient-to-t from-green-600 to-green-900 text-white w-28 h-12 rounded-3xl flex items-center justify-center text-lg font-semibold disabled:opacity-70"
        >
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            "Search"
          )}
        </button>
      </div>
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </div>
  );
};
